module.exports = __webpack_public_path__ + "static/media/STK_workshop_horiz@3x@3x.e1c68ea5.png";